import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie transport is the primary auth path. Bearer header is preserved as a
// compat fallback so localStorage sessions from before the migration keep
// working until they naturally expire.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Read the JS-readable CSRF cookie value.
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
}

api.interceptors.request.use((cfg) => {
  // Bearer token fallback (session-scoped). Reads from sessionStorage so
  // closing the window discards it.
  const legacy = sessionStorage.getItem("miro_token");
  if (legacy) cfg.headers.Authorization = `Bearer ${legacy}`;
  // Attach CSRF header on state-changing verbs when a CSRF cookie is present.
  const method = (cfg.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrf = readCookie("miro_csrf");
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  return cfg;
});

// Silent refresh on 401 for a single retry, then propagate.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    const cfg = err?.config || {};
    if (status !== 401 || cfg.__retried || cfg.url?.includes("/auth/refresh")
        || cfg.url?.includes("/auth/login")) {
      if (status === 401) {
        sessionStorage.removeItem("miro_user");
      }
      return Promise.reject(err);
    }
    try {
      if (!refreshing) refreshing = api.post("/auth/refresh");
      await refreshing;
      cfg.__retried = true;
      return api(cfg);
    } catch (e) {
      sessionStorage.removeItem("miro_user");
      return Promise.reject(err);
    } finally {
      refreshing = null;
    }
  }
);
